import { createContext, useContext } from "react";
import type { ISubscriptionsProviderContextValue } from "./SubscriptionsProvider.types";

export const SubscriptionsProviderContext = createContext<ISubscriptionsProviderContextValue>({} as ISubscriptionsProviderContextValue);

export function useSubscriptionsProviderContext() {
  return useContext(SubscriptionsProviderContext);
}
